"use client";
import React from "react";
import Link from "./webflow_modules/Basic/components/Link";

export function ButtonPrimaryBlack({ link, text = "Explore our communities" }) {
  return (
    <Link button={true} className={"button-black-primary-grow"} options={link}>
      {text}
    </Link>
  );
}
